export { default } from './App.data';
